import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getTableColumnNames, 
  GetAllTopics, 
  activeDeactiveTopics as activeDeactiveTopicsAPI,
  uploadImages,
  GetExaminationBoard,
  GetGrade,
  addTopicsAPI,
  updateTopicsAPI,
  deleteTopicsAPI,
  // Placeholder for actual API functions, ensure these are created in fakebackend_helper.js
  // addTopics as addTopicsAPI, 
  // updateTopics as updateTopicsAPI,
  // deleteTopics as deleteTopicsAPI,
  // uploadTopicsImageIcon as uploadTopicsImageIconAPI,
  // getTopicPrivilege as getTopicPrivilegeAPI,
  // addTopicPrivilege as addTopicPrivilegeAPI,
  // deleteTopicPrivilege as deleteTopicPrivilegeAPI,
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Topic Table Column Names
export const fetchTopicTableColumnNames = createAsyncThunk(
  "topics/fetchTopicTableColumnNames",
  async (params, thunkAPI) => { // Changed 'topics' to 'params' for clarity
    try {
      const response = await getTableColumnNames(params); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Fetch All Topics
export const fetchAllTopics = createAsyncThunk(
  "topics/fetchAllTopics",
  async (params, thunkAPI) => { // Changed 'topics' to 'params' for clarity
    try {
      const response = await GetAllTopics(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Add Topic
export const addTopics = createAsyncThunk(
  "topics/addTopics",
  async (topicData, thunkAPI) => {
    try {
      const response = await addTopicsAPI(topicData);
      if (response.success) {
        toast.success(t(response.message) || "Topic added successfully!");
        return response.data;
      } else {
        toast.error(response.message || "Failed to add topic.");
        return thunkAPI.rejectWithValue(response);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Update Topic
export const updateTopics = createAsyncThunk(
  "topics/updateTopics",
  async (topicData, thunkAPI) => {
  try {
    const response = await updateTopicsAPI(topicData);
    if (response.success) {
      toast.success(t(response.message) || "Topic updated successfully!");
      return response.data;
    } else {
      toast.error(response.message || "Failed to update topic.");
      return thunkAPI.rejectWithValue(response);
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Delete Topics
export const deleteTopics = createAsyncThunk(
  "topics/deleteTopics",
  async (topicIds, thunkAPI) => {
  try {
        const response = await deleteTopicsAPI(topicIds); 
        
          toast.success(t(response.message) || "SubTopic(s) deleted successfully!");
          return response.data; 
    
      } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
      }
  }
);

// Activate/Deactivate Topic
export const activateDeactivateTopics = createAsyncThunk(
  "topics/activateDeactivateTopics",
  async (topicData, thunkAPI) => {
    try {
      const response = await activeDeactiveTopicsAPI(topicData);
      if (response.success) {
        toast.success(t(response.message));
        return response.data; 
      } else {
        toast.error(response.message);
        return thunkAPI.rejectWithValue(response.message);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Upload Topic Image Icon
export const uploadTopicsImageIcon = createAsyncThunk(
  "topics/uploadTopicsImageIcon",
  async (imageData, thunkAPI) => {
  try {
    const response = await uploadImages(imageData);
    if (response.IsSuccess) {
      toast.success(t(response.message) || "Image uploaded successfully!");
      return response.Data; 
    } else {
      toast.error(t(response.message) || "Failed to upload image.");
      return thunkAPI.rejectWithValue(response);
    }
  } catch (error) {
    console.log("error",error);
    
    toast.error(error.response?.data?.message || error.message || "Something went wrong");
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

